import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../Layout';
import TitleSection from '../TitleSection';
import { API_BASE_URL, getData } from '../../helpers/ApiSettings';

const DynamicPage = () => {
  const { pageSlug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setPageData(null);
    setError(null);
    const fetchPageData = async () => {
      try {
        const response = await getData(`/pages?filters[slug][$eq]=${pageSlug}&populate=*`);

        if (!response.data.data.length>0 || !response.data.data[0].isPublished) {
          throw new Error('Page not found');
        }

        // console.log(response.data.data[0])
        setPageData(response.data.data[0]);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, [pageSlug]);

  if (loading) {
    return (
      <Layout>
        <div className="container">
          <p>Loading...</p>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="container">
          <p>Error: {error}</p>
        </div>
      </Layout>
    );
  }

  // Get the full image URL
  const featuredImageUrl = pageData.featured_image?.url
    ? `${API_BASE_URL}${pageData.featured_image.url}`
    : null;

    return (
    <Layout>
      <TitleSection 
        title={pageData.title}
        backgroundImage={featuredImageUrl}
      />
      <div className="container mb-5">
        <div className="content" dangerouslySetInnerHTML={{ __html: pageData.content }} />
      </div>
      {pageSlug === 'nos-partenaires' && (
        <div className="container mb-5">
          <div style={{ border: '2px solid #003189', borderRadius: '8px', padding: '2rem', marginTop: '2rem', display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 300px' }}>
              <h3 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>L'Europe s'engage en Guadeloupe</h3>
              <p style={{ marginBottom: '0.75rem' }}>
                Dans le cadre du dispositif <strong>Chèque TIC</strong>, cofinancé par l'Union européenne via le <strong>FEDER</strong> et la <strong>Région Guadeloupe</strong>, OVLM a bénéficié d'un soutien pour le développement de sa présence web.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '0.4rem' }}><strong>Projet&nbsp;:</strong> Présence WEB — ovlm97.fr</li>
                <li style={{ marginBottom: '0.4rem' }}><strong>Objectif&nbsp;:</strong> Améliorer la visibilité numérique et la compétitivité de l'entreprise</li>
                <li style={{ marginBottom: '0.4rem' }}><strong>Résultat&nbsp;:</strong> Création et mise en ligne du site internet ovlm97.fr</li>
                <li style={{ marginBottom: '0.4rem' }}><strong>Montant total du projet&nbsp;:</strong> 4 051,88€</li>
                <li style={{ marginBottom: '0.4rem' }}><strong>Aide européenne&nbsp;:</strong> 3 241,50€</li>
              </ul>
            </div>
            <div style={{ flex: '0 0 auto' }}>
              <img
                src="/assets/BLOC-MARQUE_GRAND-FORMAT.webp"
                alt="Bloc marque Région Guadeloupe - FEDER"
                style={{ maxWidth: '300px', height: 'auto', display: 'block' }}
              />
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default DynamicPage;